import React from 'react'
import ReactECharts from 'echarts-for-react'
import { addComma, clearComma, formatDateDomini } from '@lib/utils'
import { WriterSalesGraphTypeEnum } from '@interfaces/WriterSalesGraphTypeEnum'
import { DateTime } from 'luxon'
import { useWindowSize } from '@hooks/useWindowSize'
import { SaleAnalyticsChartProps } from './interface'

function SaleAnalyticsChart({
  data,
  graphType,
  style,
  tabId,
}: SaleAnalyticsChartProps) {
  const { isMobile } = useWindowSize()
  const chartOption = {
    grid: {
      top: 10,
      bottom: 30,
      left: isMobile ? 30 : 50,
      right: isMobile ? 10 : 30,
    },
    tooltip: {
      trigger: 'axis',
      formatter: (chart: any) => {
        const tooltipDefault = `${formatDateDomini(
          chart[0].name
        )}: <strong>${addComma(chart[0].value)}</strong>`
        const tooltipSales = `<div style="display: flex;">${formatDateDomini(
          chart[0].name
        )}: <div style="padding: 0px 5px 0px 30px;"><img src="/coin.webp" width="20" height="20" /></div><strong>${addComma(
          chart[0].value
        )}</strong></div>`
        if (tabId) {
          return tooltipSales
        }
        return tooltipDefault
      },
    },
    xAxis: {
      type: 'category',
      data: data.map(item => item.xValue.toLocaleString()),
      axisLabel: {
        formatter: (value: string) => {
          const val = clearComma(value)

          switch (graphType) {
            case WriterSalesGraphTypeEnum.HOUR:
              return DateTime.fromISO(value).toFormat('HH:mm')
            case WriterSalesGraphTypeEnum.DAY:
              return formatDateDomini(value)
            case WriterSalesGraphTypeEnum.WEEK:
              return formatDateDomini(value)
            case WriterSalesGraphTypeEnum.MONTH:
              return DateTime.fromISO(value).toFormat('LLL', {
                locale: 'th-TH',
              })
            case WriterSalesGraphTypeEnum.YEAR:
              return DateTime.fromISO(value).toFormat('yyyy', {
                locale: 'th-TH',
              })
            default:
              return value
          }
        },
      },
      axisLine: {
        lineStyle: {
          color: '#eeeeee',
          type: 'solid',
        },
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      lineStyle: {
        color: 'red',
        type: 'solid',
      },
      splitLine: {
        lineStyle: {
          color: '#eeeeee',
        },
      },
    },
    series: [
      {
        data: data.map(item => item.yValue),
        type: 'line',
        showSymbol: false,
        lineStyle: {
          width: 1,
          color: '#3f54d9',
        },
      },
    ],
    textStyle: {
      color: '#858baf',
    },
  }
  return (
    <div className='mt-[30px]'>
      <ReactECharts option={chartOption} style={style} />
    </div>
  )
}

export default SaleAnalyticsChart
